import React, { useEffect, useRef, useState } from 'react';
import { Dimensions, StyleSheet, Text, View, TouchableOpacity, Image } from 'react-native';
import * as ImagePicker from 'expo-image-picker';
import * as ImageManipulator from 'expo-image-manipulator';
import { useNavigation } from '@react-navigation/native';
import { SwiperFlatList } from 'react-native-swiper-flatlist';
import * as Location from 'expo-location';
import { manipulateAsync } from 'expo-image-manipulator';
import { Ionicons, MaterialIcons, FontAwesome, Fontisto } from '@expo/vector-icons';
import CustomAlert from './CustomAlert';
import { ActivityIndicator } from 'react-native-paper';
import { apiFetch } from '../modules/api';

export default function App() {

  const [selectedImage, setSelectedImage] = useState(null);
  const [isLoadingCamera, setIsLoadingCamera] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [alertVisible, setAlertVisible] = useState(false);
  const [onAcceptAlert, setOnAcceptAlert] = useState(null);
  const [onCancelAlert, setOnCancelAlert] = useState(null);
  const [exit, setExit] = useState(false);
  const [navigationDispatch, setNavigationDispatch] = useState({});
  const [hasCameraPermission, setHasCameraPermission] = useState(false);
  const [hasGalleryPermission, setHasGalleryPermission] = useState(false);
  const [image, setImage] = useState(null);
  const [datosCamara, setDatos] = useState(null);
  const [cameraFacingMode, setCameraFacingMode] = useState('environment');
  const [cameraStarted, setCameraStarted] = useState(false);
  const [cameraError, setCameraError] = useState('');
  const webVideoRef = useRef(null);
  const webStreamRef = useRef(null);

  const JPEG_QUALITY = gTipoFoto == 'exhibidor' ? 1 : 0.8;
  const MAX_CAPTURE_WIDTH = 1280;


  const descargarBase64 = () => {
    if (!gFoto?.base64) {
      alert("No hay contenido base64 para descargar.");
      return;
    }

    if (typeof document === 'undefined' || typeof window === 'undefined') {
      console.log('Base64 disponible solo para descarga en web');
      return;
    }

    const archivo = new Blob([gFoto.base64], { type: 'text/plain;charset=utf-8' });
    const url = window.URL.createObjectURL(archivo);
    const enlace = document.createElement('a');
    enlace.href = url;
    enlace.download = `foto-base64-${Date.now()}.txt`;
    document.body.appendChild(enlace);
    enlace.click();
    document.body.removeChild(enlace);
    window.URL.revokeObjectURL(url);
  };

  const getWebVideoConstraints = () => {
    const preferredFacingMode = cameraFacingMode;
    const alternateFacingMode = preferredFacingMode === 'environment' ? 'user' : 'environment';

    return [
      {
        name: 'hd-preferida',
        constraints: {
          audio: false,
          video: {
            facingMode: preferredFacingMode,
            width: { ideal: 1280 },
            height: { ideal: 720 },
          },
        },
      },
      {
        name: 'fullhd-preferida',
        constraints: {
          audio: false,
          video: {
            facingMode: preferredFacingMode,
            width: { ideal: 1920 },
            height: { ideal: 1080 },
          },
        },
      },
      {
        name: 'vga-preferida',
        constraints: {
          audio: false,
          video: {
            facingMode: preferredFacingMode,
            width: { ideal: 640 },
            height: { ideal: 480 },
          },
        },
      },
      {
        name: 'hd-alterna',
        constraints: {
          audio: false,
          video: {
            facingMode: alternateFacingMode,
            width: { ideal: 1280 },
            height: { ideal: 720 },
          },
        },
      },
      {
        name: 'vga-alterna',
        constraints: {
          audio: false,
          video: {
            facingMode: alternateFacingMode,
            width: { ideal: 640 },
            height: { ideal: 480 },
          },
        },
      },
      {
        name: 'camara-preferida',
        constraints: {
          audio: false,
          video: {
            facingMode: preferredFacingMode,
          },
        },
      },
      {
        name: 'stream-basico',
        constraints: {
          audio: false,
          video: true,
        },
      },
    ];
  };

  const esperarFramesVideo = (videoElement, timeoutMs = 2500) => {
    return new Promise((resolve) => {
      const start = Date.now();

      const validar = () => {
        if (videoElement?.videoWidth > 0 && videoElement?.videoHeight > 0 && !videoElement.paused) {
          resolve(true);
          return;
        }

        if (Date.now() - start >= timeoutMs) {
          resolve(false);
          return;
        }

        window.requestAnimationFrame(validar);
      };

      validar();
    });
  };

  const registrarStreamWeb = (videoElement = webVideoRef.current, stream = webStreamRef.current) => {
    const track = stream?.getVideoTracks?.()[0];
    const streamInfo = {
      videoWidth: videoElement?.videoWidth || null,
      videoHeight: videoElement?.videoHeight || null,
      trackSettings: track?.getSettings?.() || null,
    };

    setDatos((prevDatos) => ({
      ...prevDatos,
      streamInfo,
    }));
    console.log('stream web real:', streamInfo);
  };

  const detenerCamaraWeb = () => {
    if (webStreamRef.current) {
      webStreamRef.current.getTracks().forEach((track) => track.stop());
      webStreamRef.current = null;
    }

    if (webVideoRef.current) {
      webVideoRef.current.srcObject = null;
    }
    setIsLoadingCamera(false);
    setCameraError('');
    setCameraStarted(false);
  };

  const iniciarCamaraWeb = async () => {
    if (!navigator.mediaDevices?.getUserMedia) {
      setCameraError('El navegador no soporta getUserMedia.');
      return;
    }

    detenerCamaraWeb();
    setIsLoadingCamera(true);
    setCameraError('');

    try {
      let stream = null;
      let selectedProfile = null;

      for (const profile of getWebVideoConstraints()) {
        try {
          const candidateStream = await navigator.mediaDevices.getUserMedia(profile.constraints);

          if (!webVideoRef.current) {
            stream = candidateStream;
            selectedProfile = profile.name;
            break;
          }

          webVideoRef.current.srcObject = candidateStream;
          webVideoRef.current.muted = true;
          webVideoRef.current.autoplay = true;
          webVideoRef.current.playsInline = true;
          webVideoRef.current.setAttribute('muted', 'true');
          webVideoRef.current.setAttribute('autoplay', 'true');
          webVideoRef.current.setAttribute('playsinline', 'true');

          try {
            await webVideoRef.current.play();
          } catch (playError) {
            console.log('No se pudo reproducir candidato de camara:', playError);
          }

          const hasFrames = await esperarFramesVideo(webVideoRef.current);

          if (hasFrames) {
            stream = candidateStream;
            selectedProfile = profile.name;
            console.log('stream web aceptado con perfil:', profile.name, profile.constraints);
            break;
          }

          candidateStream.getTracks().forEach((track) => track.stop());
          console.log('stream web sin frames para perfil:', profile.name);
        } catch (profileError) {
          console.log('stream web rechazado para perfil:', profile.name, profileError);
        }
      }

      if (!stream) {
        throw new Error('No se pudo abrir ningun perfil de camara web.');
      }

      webStreamRef.current = stream;
      setCameraStarted(true);

      if (webVideoRef.current) {
        webVideoRef.current.srcObject = stream;
        webVideoRef.current.muted = true;
        webVideoRef.current.autoplay = true;
        webVideoRef.current.playsInline = true;
        webVideoRef.current.onloadedmetadata = async () => {
          try {
            await webVideoRef.current.play();
          } catch (playError) {
            console.log('No se pudo reproducir el video de la camara:', playError);
          }

          console.log('perfil de stream web seleccionado:', selectedProfile);
          registrarStreamWeb(webVideoRef.current, stream);
          setIsLoadingCamera(false);
        };
        webVideoRef.current.oncanplay = async () => {
          try {
            await webVideoRef.current.play();
          } catch (playError) {
            console.log('No se pudo reproducir el video de la camara en canplay:', playError);
          }
        };
      } else {
        setIsLoadingCamera(false);
      }
    } catch (error) {
      setIsLoadingCamera(false);
      setCameraError(error?.message || 'No se pudo iniciar la camara del navegador.');
      console.log('No se pudo iniciar la camara web:', error);
    }
  };

  useEffect(() => {
    if (image || exit) {
      return undefined;
    }

    return () => {
      detenerCamaraWeb();
    };
  }, [image, exit]);

  useEffect(
    () =>
      navigation.addListener('beforeRemove', (e) => {
        console.log("preventCamera");
        setExit(true);
        e.preventDefault();
        setNavigationDispatch(e);
        /*
        setOnAcceptAlert(() => () => {navigation.dispatch(e.data.action)});
        setOnCancelAlert(() => () => resetAlert());*/
      }),
    [navigation]
  );

  async function checkCameraPermission() {
    if (!navigator.permissions) {
      console.warn("Permissions API no disponible en este navegador");
      return;
    }

    try {
      const result = await navigator.permissions.query({ name: "camera" });

      if (result.state === "denied") {
        alert("No tienes permiso para usar la cámara.");
        navigation.goBack()
      }

      // Si quieres reaccionar a cambios:
      result.onchange = () => {
        if (result.state === "denied") {
          alert("Se bloqueó el permiso de cámara.");
          navigation.goBack()
        }
      };

    } catch (e) {
      console.log("No se pudo consultar el permiso de cámara:", e);
    }
  }

  useEffect(() => {
    if (exit && navigationDispatch?.data) {
      setTimeout(() => {
        navigation.dispatch(navigationDispatch.data.action);
      }, 500);
    }
  }, [exit, navigationDispatch])

  const openImagePickerAsync = async () => {
    const permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();
    if (permissionResult.granted === false) {
      alert("Se requieren permisos para accesar al carrete de fotos!");
      return;
    }

    const pickerResult = await ImagePicker.launchImageLibraryAsync();
    if (pickerResult.canceled === true) {
      return;
    }


    gFoto = await manipulateAsync(
      pickerResult.assets[0].uri, [

    ],
      {
        compress: 1,
        format: ImageManipulator.SaveFormat.JPEG,
        aspect: [4, 3],
        base64: true,
      });


    setImage(pickerResult.assets[0].uri);
    setSelectedImage({ localUri: pickerResult.assets[0].uri });
    origenFoto = "galeria";
  };

  const navigation = useNavigation();

  const recargar = () => {

    navigation.replace(
      'Fotos',
      null,
      null,


    );

  }
  const [zoom, setZoom] = useState(0);




  useEffect(function () {
    setExit(false);
    checkCameraPermission();
    let mounted = true;
    gPantalla = "";
    async function obtenerFotos() {

      if (mounted) {
        if (gMostrarFoto != 'si') {

          gFoto1 = "";
          gFoto2 = "";
          gFoto3 = "";
          gFoto4 = "";
          gFoto5 = "";
          gFoto6 = "";
          gFoto7 = "";
          gFoto8 = "";
          gFoto9 = "";
          gFoto10 = "";
          const datos = '{"determinante" : "' + gDeterminante + '","operador" : "' + gOperador + '","tipo" : "' + gTipoFoto + '"}'
          const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: datos
          }

          const response = await apiFetch(gApiPath + "/api/listarFotos", requestOptions);
          const json = await response.json();

          if (json.estatus == "bien") {
            iniciarCamaraWeb();

            var listadoFotos = json.datos;

            gFotoid = {};
            for (var i = 0; i < listadoFotos.length; i++) {

              var ruta = gApiPathFoto + listadoFotos[i].imagen;
              gFotoid[ruta] = listadoFotos[i].id;

              if (gFoto1 === "") {
                gFoto1 = ruta;

              } else if (gFoto2 === "") {
                gFoto2 = ruta;

              } else if (gFoto3 === "") {
                gFoto3 = ruta;

              } else if (gFoto4 === "") {
                gFoto4 = ruta;

              } else if (gFoto5 === "") {
                gFoto5 = ruta;

              } else if (gFoto6 === "") {
                gFoto6 = ruta;

              } else if (gFoto7 === "") {
                gFoto7 = ruta;

              } else if (gFoto8 === "") {
                gFoto8 = ruta;

              } else if (gFoto9 === "") {
                gFoto9 = ruta;

              } else if (gFoto10 === "") {
                gFoto10 = ruta;

              }


            }


          }

        }

        (async () => {
          if (!hasCameraPermission) {
            setHasCameraPermission(true);
            setHasGalleryPermission(true)
          }

        })();
      }
    }
    obtenerFotos();

  }, []);

  function regresar() {
    gMostrarFoto = "no";
    gVerFoto = "";
    recargar();
  };



  function carrete_lleno() {

    if (gFoto1 == "" || gFoto2 == "" || gFoto3 == "" || gFoto4 == "" || gFoto5 == "" || gFoto6 == "" || gFoto7 == "" || gFoto8 == "" || gFoto9 == "" || gFoto10 == "") {

      global.carreteLleno = false;


    } else {

      global.carreteLleno = true;

    }





    return global.carreteLleno;


  }


  /*async function validarGpsEncendido(){

    let { status } = await Location.requestForegroundPermissionsAsync();
    
        if (status !== 'granted') {
            setErrorMsg('Permission to access location was denied');
            gMsg = "Para poder utilizar esta aplicación es necesario dar permiso de ubicación a esta aplicación"
            showAlert();
            navigation.navigate("Acceso");
            return;
        }else{
          let location = await Location.watchPositionAsync(
            {accuracy:Location.Accuracy.High,
            timeInterval:5000,
            distanceInterval:10
          },
            (loc) => {
              gGeo = loc.coords;
            }
            );
        }
  }*/


  const [errorMsg, setErrorMsg] = useState(null);

  async function grabarImagenes() {

    setErrorMsg(null);
    let { status } = await Location.requestForegroundPermissionsAsync();
    if (status !== 'granted') {
      setErrorMsg('Permission to access location was denied');
      navigation.navigate("Acceso");
      return;
    }

    /*try{
    var altitude = gGeo.altitude
    var latitude = gGeo.latitude
    var longitude = gGeo.longitude
    }catch{

      validarGpsEncendido();

    }*/

    var altitude = ""
    var latitude = ""
    var longitude = ""
    let datos = '{"tipo" :"' + gTipoFoto + '",' + '"imagen" : "' + gFoto.base64 + '", operador : "' + gOperador + '","determinante" : "' + gDeterminante + '", "upc" : "","altitude":"' + altitude + '","latitude":"' + latitude + '","longitude":"' + longitude + '","origen":"' + origenFoto + '"}'

    let requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos
    };

    const response = await apiFetch(gApiPath + "/api/guardarFoto", requestOptions);
    const json = await response.json();
    gVerFoto = "";
    await deletePicture();
    recargar();
    gMostrarFoto = "no"

  }

  async function eliminarImagen(f) {

    var idDelete = gFotoid[gVerFoto];
    gFotoid[gVerFoto] = 0;

    switch (gVerFoto) {
      case gFoto1:
        gFoto1 = "";
        break;
      case gFoto2:
        gFoto2 = "";
        break;
      case gFoto3:
        gFoto3 = "";
        break;
      case gFoto4:
        gFoto4 = "";
        break;
      case gFoto5:
        gFoto5 = "";
        break;
      case gFoto6:
        gFoto6 = "";
        break;
      case gFoto7:
        gFoto7 = "";
        break;
      case gFoto8:
        gFoto8 = "";
        break;
      case gFoto9:
        gFoto9 = "";
        break;
      case gFoto10:
        gFoto10 = "";
        break;

    }

    let datos = '{"id" : "' + idDelete + '"}';

    let requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: datos

    };

    const response = await apiFetch(gApiPath + "/api/borrarFotoPromo", requestOptions);
    const json = await response.json();

    gMostrarFoto = "no";
    recargar();

  }


  async function rotarFoto() {


    global.gFoto = await manipulateAsync(
      gFoto.uri, [
      { rotate: 90 },
    ],
      {
        compress: 1,
        format: ImageManipulator.SaveFormat.JPEG,
        aspect: [2, 1],
        base64: true,
      });
    setImage(gFoto.uri);
  }

  function alertEliminar(f) {
    setAlertText("¿Desea eliminar la imagen seleccionada?");
    setOnAcceptAlert(() => () => eliminarImagen(f));
    setOnCancelAlert(() => () => setAlertVisible(false));
    setAlertVisible(true);
  }

  const fotos = [

    gFoto1,
    gFoto2,
    gFoto3,
    gFoto4,
    gFoto5,
    gFoto6,
    gFoto7,
    gFoto8,
    gFoto9,
    gFoto10

  ];


  function verFoto(f) {

    gMostrarFoto = 'si';
    gVerFoto = f;

    recargar();

  }


  function agregarFoto(f) {

    if (gFoto1 == "") {
      gFoto1 = f
    } else if (gFoto2 == "") {
      gFoto2 = f
    } else if (gFoto3 == "") {
      gFoto3 = f
    } else if (gFoto4 == "") {
      gFoto4 = f
    } else if (gFoto5 == "") {
      gFoto5 = f
    } else if (gFoto6 == "") {
      gFoto6 = f
    } else if (gFoto7 == "") {
      gFoto7 = f
    } else if (gFoto8 == "") {
      gFoto8 = f
    } else if (gFoto9 == "") {
      gFoto9 = f
    } else if (gFoto10 == "") {
      gFoto10 = f
    };

    grabarImagenes();
  }



  const takePicture = async () => {
    if (!webVideoRef.current) {
      alert('La camara aun no esta lista para capturar.');
      return;
    }

    origenFoto = "app";

    let width = webVideoRef.current.videoWidth;
    let height = webVideoRef.current.videoHeight;

    if (!width || !height) {
      const ready = await esperarFramesVideo(webVideoRef.current, 4000);
      if (!ready) {
        alert('La camara aun no esta lista para capturar.');
        return;
      }

      width = webVideoRef.current.videoWidth;
      height = webVideoRef.current.videoHeight;
    }

    const scale = width > MAX_CAPTURE_WIDTH ? MAX_CAPTURE_WIDTH / width : 1;
    const outputWidth = Math.round(width * scale);
    const outputHeight = Math.round(height * scale);

    const canvas = document.createElement('canvas');
    canvas.width = outputWidth;
    canvas.height = outputHeight;

    const context = canvas.getContext('2d');
    context.drawImage(webVideoRef.current, 0, 0, outputWidth, outputHeight);

    const dataUrl = canvas.toDataURL('image/jpeg', JPEG_QUALITY);
    const base64 = dataUrl.split(',')[1];
    const streamInfo = {
      videoWidth: width,
      videoHeight: height,
      trackSettings: webStreamRef.current?.getVideoTracks?.()[0]?.getSettings?.() || null,
    };

    gFoto = {
      uri: dataUrl,
      base64,
      width: outputWidth,
      height: outputHeight,
    };

    setDatos({
      width: outputWidth,
      height: outputHeight,
      pictureSize: `${outputWidth}x${outputHeight}`,
      exif: null,
      streamInfo,
      compression: {
        jpegQuality: JPEG_QUALITY,
        maxCaptureWidth: MAX_CAPTURE_WIDTH,
      },
    });
    setImage(dataUrl);
    detenerCamaraWeb();
  }

  const deletePicture = async () => {
    if (image) {
      //await FileSystem.deleteAsync(image, { idempotent: true });
      setImage(null)
      iniciarCamaraWeb();
    }
  }

  async function addPicture() {
    if (image) {
      agregarFoto(gFoto.uri);
    }
  }

  const pickImage = async () => {
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Image,
      allowsEditing: true,
      aspect: [1, 1],
      quality: 1,
      base64: true,

    });

    if (!result.cancelled) {
      setImage(result.uri);
    }
  };
  if (hasCameraPermission === null || hasGalleryPermission === false) {
    return <View />;
  }
  if (hasCameraPermission === false || hasGalleryPermission === false) {
    return <Text>Sin Acceso a la camara</Text>;
  }

  const handleChangeCamera = () => {
    setIsLoadingCamera(true);
    setTimeout(() => {
      setCameraFacingMode(
        cameraFacingMode === 'environment'
          ? 'user'
          : 'environment'
      );
      if (webStreamRef.current) {
        iniciarCamaraWeb();
      }
    }, 2000);
  }


  return (

    <View style={styles.container}>
      <CustomAlert alertVisible={alertVisible} setAlertVisible={setAlertVisible} text={alertText} onAccept={onAcceptAlert} onCancel={onCancelAlert} />
      <View style={styles.cameraContainer}>

        {(gMostrarFoto === 'no') ?
          (image) ?
            <Image source={{ uri: image }} style={styles.camera} /> :
            (!exit) ?
              <>
                <video
                  ref={webVideoRef}
                  autoPlay
                  playsInline
                  muted
                  style={{
                    height: '80%',
                    width: '100%',
                    objectFit: 'cover',
                    backgroundColor: '#000',
                  }}
                />
                {!cameraStarted ? (
                  <View style={styles.cameraStartOverlay}>
                    {cameraError ? <Text style={styles.cameraErrorText}>{cameraError}</Text> : null}
                  </View>
                ) : null}
                {isLoadingCamera ? <ActivityIndicator animating={true} size={'large'} color={'white'} style={styles.loadingIndicator} /> : null}
              </> :
              <></>
          : <></>}
        {(gMostrarFoto === 'no') ?
          (image) ?

            <View style={{ marginVertical: "15%", bottom: "5%", justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
              <TouchableOpacity onPress={() => deletePicture()} style={{ paddingRight: 60 }}>
                <Ionicons name="md-arrow-back-circle-sharp" size={54} color="white" />
              </TouchableOpacity>
              <TouchableOpacity onPress={() => addPicture()}>
                <Ionicons name="ios-add-circle-sharp" size={74} color="white" />
              </TouchableOpacity>
              <TouchableOpacity onPress={() => rotarFoto(gFoto)} style={{ paddingLeft: 60 }}>
                <Fontisto name="spinner-refresh" size={54} color="white" />
              </TouchableOpacity>
            </View>

            : (carrete_lleno()) ?
              <View style={{ bottom: "20%", paddingTop: "10%", justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}></View>
              :

              <View style={{ bottom: "20%", justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                {/*<TouchableOpacity  onPress={openImagePickerAsync}  style={{  paddingRight:60}}>
                <FontAwesome name="file-image-o" size={44} color="black" />
              </TouchableOpacity>*/}
                {!isLoadingCamera ? (
                  <View style={{ justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
                    <View >
                      <TouchableOpacity onPress={() => takePicture()} >
                        <FontAwesome name="camera" size={44} color="white" style={styles.shadow} />
                      </TouchableOpacity>
                    </View>
                    <View style={{ marginLeft: 60, height: 42, ...styles.shadow, borderRadius: 10 }}>
                      <TouchableOpacity onPress={() => {
                        handleChangeCamera();
                      }}>
                        <Ionicons name="camera-reverse-sharp" size={54} color="white" style={{ top: -8, height: 50 }} />
                      </TouchableOpacity>
                    </View>
                  </View>
                ) : (
                  <ActivityIndicator animating={true} size={'large'} color={'white'} />
                )}
              </View>
          : null}

        {(gMostrarFoto === 'no') ? (image) ? null :
          <>{/*<View style={{ flexDirection: 'row', marginVertical: "15%", bottom: "15%" }}>
          <Text style={styles.textLabels}>Zoom</Text>
          <Slider
            style={{ width: "70%", height: 40 }}
            thumbTintColor={theme.colors.primary}
            minimumValue={0}
            maximumValue={1}
            minimumTrackTintColor="#fff"
            maximumTrackTintColor="#fff"
            onValueChange={value => setZoom(value)}
          />
        </View>*/}</>

          : null}

        {gMostrarFoto === 'si' ? <Image source={{ uri: gVerFoto }} style={styles.camera} /> : null}
        {(gMostrarFoto === 'si') ? <View style={{ marginVertical: "10%", bottom: "3%", justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}>
          <TouchableOpacity onPress={() => regresar()} style={{ paddingRight: 60 }}>
            <Ionicons name="md-arrow-back-circle-sharp" size={54} color="white" />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => alertEliminar(gFoto.uri)} style={{ paddingLeft: 60 }}>
            <MaterialIcons name="delete-forever" size={54} color="white" />
          </TouchableOpacity>
        </View> : null}

      </View>

      <View style={styles.container2}>

        <SwiperFlatList
          data={fotos}

          renderItem={({ item }) => (

            <View style={styles.child}>

              <TouchableOpacity onPress={() => item != '' ? verFoto(item) : null}>
                <Image source={item === '' ? { uri: gApiPathFoto + 'xxxzzzppp.jpg' } : { uri: item }} style={{ width: 90, height: 60, alignItems: 'center', justifyContent: 'center' }} />

              </TouchableOpacity>
            </View>

          )}
        />
      </View>

    </View>
  );
}
const { width } = Dimensions.get('screen');
const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignContent: 'center',
    backgroundColor: '#000'
  },
  camera: {
    height: "80%",
    width: "100%",
  },
  cameraContainer: {
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    top: "5%",
    backgroundColor: '#000'
  },
  button: {
    flex: 1,
  },
  tomarFoto: {
    width: "20%",
    height: 50,
    borderRadius: 70,
    alignItems: 'center',
    justifyContent: 'center'
  }, container2: {
    height: "10%",
    width: '100%',
  },

  child: {
    alignSelf: 'center',
    resizeMode: 'contain',
    alignItems: 'center',
    justifyContent: 'center'
  },

  text: {
    fontSize: 30,
    textAlign: 'center'
  }
  , responsiveImage: {
    width: '100%',
    height: undefined,
    aspectRatio: 1 / 1,
    alignItems: 'center',
    justifyContent: 'center',

  },

  titulo1: {
    fontSize: 30,
    color: "white",
    fontWeight: 'bold',
    marginTop: 10,
  },

  titulo2: {
    fontSize: 35,
    color: "black",
    fontWeight: 'bold'
  },
  buttonFoto: {
    backgroundColor: '#007aff',
    borderRadius: 50,
    width: 100,
    height: 100,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textLabels: {

    padding: 5,
    alignItems: 'center',
    fontWeight: 'bold',
    color: 'white',
    fontSize: 20
  },
  shadow: {
    color: "white",
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: 10
  },
  loadingIndicator: {
    position: 'absolute',
    alignSelf: 'center',
  },
  cameraStartOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: '20%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.45)',
  },
  cameraStartButton: {
    paddingVertical: 12,
    paddingHorizontal: 18,
    borderRadius: 10,
    backgroundColor: '#ffffff',
  },
  cameraStartButtonText: {
    color: '#000',
    fontWeight: '700',
    fontSize: 16,
  },
  cameraErrorText: {
    marginTop: 12,
    color: '#fff',
    textAlign: 'center',
    paddingHorizontal: 16,
  }
});